import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface EventPayload {
    type: string;
    payload?: any;
}

@Injectable({ providedIn: 'root' })
export class EventBusService {
    private readonly eventSubject = new Subject<EventPayload>();

    emit(event: EventPayload): void {
        this.eventSubject.next(event);
    }

    on(eventType: string): Observable<EventPayload> {
        return this.eventSubject.asObservable().pipe(filter((event) => event.type === eventType));
    }
}
